// src/components/LandingPage/Hero.tsx

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[480px] sm:min-h-[560px] lg:h-[550px] mt-[64px] lg:mt-[72px] overflow-hidden"
    >

      {/* ✅ Existing gradient overlay stays above animation */}
      <div className="absolute inset-0 z-[1]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(152.96deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.55) 50%, rgba(28,57,142,0.4) 100%)",
          }}
        />
      </div>

      {/* ✅ Your existing content stays untouched & remains above */}
      <div className="relative z-[2] max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center py-16 lg:py-0">
        <div className="max-w-[896px] text-left">
          <h1 className="mb-2">
            <span
              className="block text-3xl sm:text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[75px] font-light bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, rgb(255,255,255) 0%, rgb(190,219,255) 100%)",
              }}
            >
              Unleash Innovation. Solve Challenges. Build the Future.
            </span>
          </h1>

          <p className="text-white text-base sm:text-lg lg:text-[20px] leading-relaxed mt-4 lg:mt-6 max-w-[742px] text-left">
            Empower your journey with guided challenges, expert mentors, and an ecosystem designed to help you grow, build, and win.
          </p>

          <button className="mt-6 lg:mt-8 bg-[#0058AB] text-white px-6 lg:px-8 py-3 lg:py-4 rounded-full text-sm lg:text-base font-medium hover:bg-opacity-90 transition-opacity">
            Explore Hackathons
          </button>
        </div>
      </div>
    </section>
  );
}